// DEMO ONLY. The Pinned "All response types (test)" chat: every page response type and status in
// one conversation. It holds no block data of its own; each turn references the owning group's
// seed, so a group that fills in its seeds updates this chat with no edit here.
import { ANSWER_SEEDS } from './answerSeeds';
import { HANDOFF_SEEDS } from './handoffSeeds';
import { IOrbitPageDemoChat, seedTurn } from './seedTurn';
import { SUPPORT_SEEDS } from './supportSeeds';

export const ORBIT_PAGE_SHOWCASE_ID = 'response-showcase';

const { ticketForm, renewal } = SUPPORT_SEEDS;
const { handoff } = HANDOFF_SEEDS;

export const ORBIT_PAGE_SHOWCASE: IOrbitPageDemoChat = {
  id: ORBIT_PAGE_SHOWCASE_ID,
  title: 'All response types (test)',
  chips: [],
  turns: [
    seedTurn('Show the support ticket form.', [ticketForm('draft')]),
    seedTurn('Show the ticket form while it submits.', [ticketForm('processing')]),
    seedTurn('Show the ticket form once the ticket exists.', [ticketForm('success')]),
    seedTurn('Show the ticket form when submitting fails.', [ticketForm('error')]),
    seedTurn(SUPPORT_SEEDS.ticketQuestion, [SUPPORT_SEEDS.clarifyingWithQuickReplies]),
    seedTurn('Show me our active support tickets.', [SUPPORT_SEEDS.ticketTable]),
    seedTurn('Open ticket PRX-8491.', [SUPPORT_SEEDS.ticketRecord]),
    seedTurn('Schedule a renewal review.', [renewal('draft')]),
    seedTurn('Show the renewal review once submitted.', [renewal('success')]),
    seedTurn(ANSWER_SEEDS.weeklyQuestion, [ANSWER_SEEDS.weeklyUpdate]),
    seedTurn(ANSWER_SEEDS.multiQuestion, [ANSWER_SEEDS.multiAnswer]),
    seedTurn(ANSWER_SEEDS.reportQuestion, [ANSWER_SEEDS.reportGenerated]),
    seedTurn(ANSWER_SEEDS.chartQuestion, [ANSWER_SEEDS.governedAnalysis]),
    seedTurn('Send this to the Growth Planner.', [handoff('preparing')]),
    seedTurn('Which metrics can I hand off?', [handoff('choosing')]),
    seedTurn('Show the hand-off while it sends.', [handoff('sending')]),
    seedTurn('Show the hand-off once sent.', [handoff('sent')]),
    seedTurn('Show the hand-off when it fails.', [handoff('failed')])
  ]
};
